import { Controller } from '@hotwired/stimulus'
import { createMetricDialogPanel, type Tab } from '../../services/progress_panel'

export default class extends Controller {
  static targets = [
    'dialog',
    'payload',
    'eyebrow',
    'title',
    'subtitle',
    'summary',
    'tab',
    'heading',
    'headingLabel',
    'headingMeta',
    'body',
    'table',
    'empty'
  ]

  declare readonly dialogTarget: HTMLDialogElement
  declare readonly payloadTarget: HTMLScriptElement
  declare readonly eyebrowTarget: HTMLElement
  declare readonly titleTarget: HTMLElement
  declare readonly subtitleTarget: HTMLElement
  declare readonly summaryTarget: HTMLElement
  declare readonly tabTargets: HTMLButtonElement[]
  declare readonly headingTarget: HTMLTableSectionElement
  declare readonly headingLabelTarget: HTMLTableCellElement
  declare readonly headingMetaTarget: HTMLTableCellElement
  declare readonly bodyTarget: HTMLTableSectionElement
  declare readonly tableTarget: HTMLTableElement
  declare readonly emptyTarget: HTMLElement

  private panel!: ReturnType<typeof createMetricDialogPanel>

  connect() {
    this.panel = createMetricDialogPanel({
      dialog: this.dialogTarget,
      payload: this.payloadTarget,
      eyebrow: this.eyebrowTarget,
      title: this.titleTarget,
      subtitle: this.subtitleTarget,
      summary: this.summaryTarget,
      heading: this.headingTarget,
      headingLabel: this.headingLabelTarget,
      headingMeta: this.headingMetaTarget,
      body: this.bodyTarget,
      table: this.tableTarget,
      empty: this.emptyTarget,
      tabs: this.tabTargets
    })
  }

  open(event: Event) {
    event.preventDefault()
    const trigger = event.currentTarget as HTMLElement | null

    if (this.panel.open(trigger?.dataset.metricStoriesKey)) this.dialogTarget.showModal()
  }

  selectTab(event: Event) {
    const trigger = event.currentTarget as HTMLElement | null
    const tab = trigger?.dataset.tab as Tab | undefined

    if (tab) this.panel.showTab(tab)
  }

  close() {
    this.panel.close()
  }

  dismissOnBackdrop(event: Event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
